import { AnimatePresence } from 'framer-motion';

import useCtaButtonAnimation from '../../../../../hooks/useCtaButtonAnimation';
import * as Styled from '../../../ctaButton.styles';

interface Props {
  openModal: () => void;
  buttonText: string;
}

const FormOpenButton = ({ openModal, buttonText }: Props) => {
  const {
    buttonAnimationControls,
    textAnimationControls,
    textWrapperAnimationControls,
  } = useCtaButtonAnimation();

  return (
    <AnimatePresence mode="wait">
      <Styled.AnimationWrapper animate={buttonAnimationControls}>
        <Styled.CtaAnimationButton
          animate={textWrapperAnimationControls}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          onClick={openModal}
        >
          <Styled.CtaButtonText
            animate={textAnimationControls}
            variant="lg-semibold"
            color="white"
            transition={{ duration: 0.05, ease: 'easeInOut' }}
          >
            {buttonText}
          </Styled.CtaButtonText>
        </Styled.CtaAnimationButton>
      </Styled.AnimationWrapper>
    </AnimatePresence>
  );
};

export default FormOpenButton;
